import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { API } from "@/App";
import { TrendingUp, Eye } from "lucide-react";

const TrendingSection = () => {
  const [trending, setTrending] = useState(null);
  const { t } = useTranslation();

  useEffect(() => {
    axios.get(`${API}/trending`).then(r => setTrending(r.data)).catch(() => {});
  }, []);

  if (!trending) return null;

  const items = [
    ...(trending.universes || []).slice(0, 3).map(u => ({ ...u, _type: "universe", link: `/universe/${u.slug}` })),
    ...(trending.characters || []).slice(0, 3).map(c => ({ ...c, _type: "character", link: `/character/${c.id}` })),
  ];

  if (!items.length) return null;

  return (
    <div data-testid="trending-section">
      <div className="flex items-center gap-2 mb-5">
        <TrendingUp className="w-5 h-5 text-amber-500" />
        <h2 className="text-2xl sm:text-3xl font-bold text-white font-['Outfit']">{t("home.trendingNow")}</h2>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3">
        {items.map((item, i) => (
          <Link
            key={`${item._type}-${item.id}`}
            to={item.link}
            className="group relative rounded-xl overflow-hidden aspect-[3/4] bg-[#0B0F19] border border-white/5 hover:border-amber-500/30 transition-all"
            data-testid={`trending-item-${i}`}
          >
            {(item.cover_image || item.image || item.images?.[0]) ? (
              <img
                src={item.cover_image || item.image || item.images?.[0]}
                alt={item.name}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            ) : (
              <div className="w-full h-full bg-gradient-to-br from-amber-500/10 to-purple-500/10" />
            )}
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-3">
              <span className={`text-[9px] font-mono uppercase tracking-wider ${item._type === "universe" ? "text-amber-400" : "text-purple-400"}`}>
                {item._type}
              </span>
              <p className="text-white text-sm font-semibold font-['Outfit'] leading-tight mt-0.5 line-clamp-2 group-hover:text-amber-400 transition-colors">
                {item.name}
              </p>
              {item.view_count && (
                <div className="flex items-center gap-1 mt-1">
                  <Eye className="w-3 h-3 text-slate-500" />
                  <span className="text-[10px] text-slate-500">{item.view_count}</span>
                </div>
              )}
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default TrendingSection;
